import { render, staticRenderFns } from "./ValueDefault.vue?vue&type=template&id=0ac45a9e&"
import script from "./ValueDefault.vue?vue&type=script&lang=js&"
export * from "./ValueDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ValueDefault.vue"
export default component.exports